import Swal from "sweetalert2";

type AlertType = "success" | "error" | "warning" | "info" | "question";

/* -------------------------------------------------
   TOAST (non-blocking)
-------------------------------------------------- */
export const showToast = ({
  icon,
  title,
  text,
  html,
  timer = 3000,
  position = "top-end",
}: {
  icon: AlertType;
  title: string;
  text?: string;
  html?: string;
  timer?: number;
  position?:
    | "top"
    | "top-start"
    | "top-end"
    | "center"
    | "bottom"
    | "bottom-start"
    | "bottom-end";
}) => {
  Swal.fire({
    toast: true,
    position,
    icon,
    title: `<b>${title}</b>`,
    text,
    html,
    timerProgressBar: true,
    timer,
    showConfirmButton: false,
  });
};

/* -------------------------------------------------
   ALERT (blocking modal)
-------------------------------------------------- */
export const showAlert = async ({
  icon = "info",
  title,
  text,
  html,
  confirmButtonText = "OK",
  cancelButtonText,
  showCancelButton = false,
}: {
  icon?: AlertType;
  title: string;
  text?: string;
  html?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  showCancelButton?: boolean;
}) => {
  return await Swal.fire({
    icon,
    title,
    text,
    html,
    showCancelButton,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: "#0d6efd",
    cancelButtonColor: "#6c757d",
  });
};
